import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      // 查询表单绑定值
      form: {
        personName: null // 姓名
      },
      // 查询表单基础数据
      formSearchList: [
        {
          type: "input",
          label: "姓名：",
          value: "personName",
          placeholder: "请输入",
          clearable: true
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "姓名",
          prop: "personName",
          isShow: true
        },
        {
          label: "性别",
          prop: "sexNum"
        },
        {
          label: "证件类型",
          prop: "idCardTypeName"
        },
        {
          label: "证件号码",
          prop: "idCard"
        },
        {
          label: "出生日期",
          prop: "birthDay"
        },
        {
          label: "手机号码",
          prop: "mobile"
        }
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0
    };
  },

  // 接收父组件传递的数据
  props: {},

  // 模板编译完成
  mounted() { },
  // 自定义方法
  methods: {
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList(czbz, auditState) {
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/regPersonBasicinfoChoose/list", {
        czbz: czbz,
        auditState: auditState,
        ...this.form,
        ...this.reqPageData,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 项目负责人选择
     */
    fun_RegPersonSelect(e) {
      // 回调函数
      this.$nextTick(() => {
        // 赋值父页面注册人员主键
        this.$parent.form.constructorId = e.val.id;
        // 赋值父页面注册人员名称
        this.$parent.form.projectPrincipalName = e.val.personName;
        // 赋值父页面注册人员证件类型
        this.$parent.form.idCardTypeNum = e.val.idCardTypeNum;
        // 赋值父页面注册人员证件号码
        this.$parent.form.idCard = e.val.idCard;
        // 赋值父页面注册人员主键
        this.$parent.form.regPersonId = e.val.id;
        // 赋值父页面注册人员主键
        this.$parent.form.regPersonName = e.val.personName;
        // 关闭页面弹框
        this.dialogVisible = false;
      });
    },

    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
  }
};
